import { Component } from "react";
import { connect } from "react-redux";
import { isMemberInCurrentCommittee } from "./../../../state/user/selectors";
import { hasWriteAccess } from "../../../state/user/selectors";

class OnlyMember extends Component {
  render() {
    const {
      children,
      isMemberInCurrentCommittee,
      allowConsultant,
      hasWriteAccess,
    } = this.props;
    return isMemberInCurrentCommittee || (allowConsultant && hasWriteAccess)
      ? children
      : null;
  }
}

const mapStateToProps = (state) => ({
  isMemberInCurrentCommittee: isMemberInCurrentCommittee(state),
  hasWriteAccess: hasWriteAccess(state),
});

export default connect(mapStateToProps)(OnlyMember);
